import React, { useEffect, useState, useContext } from "react";
import Landing from "./Components/Landing";
import { toast } from "react-toastify";
import { apiCall } from "../../utils/httpClient";
import ApiEndPoint from "../../utils/apiEndPoints";
import { LoaderContext } from "../../Context/userContext";
import { HomePageEndpoints } from "../../utils/apiEndPoints";

const LandingScreen = () => {
    const [IsLoading, setIsLoading] = useContext(LoaderContext);
    // const { lungClicked, setLungClicked } = useContext(SourceContext);
    const [treatmentDetails, setTreatmentDetails] = useState([]);
    const [drugTherapy, setDrugTherapy] = useState([]);
    const [biologicalTherapy, setBiologicalTherapy] = useState([])
    const [treatmentsTotal, setTreatmentsTotal] = useState(0);
    const [drugTotal, setDrugTotal] = useState(0);
    const [biologicalTotal, setBiologicalTotal] = useState(0);
    const [top10Cancersite, setTop10Cancersite] = useState([]);
    const [multiModal, setMultiModal] = useState(null);
    const [proteomics, setProteomics] = useState([]);
    const [totalPatientCount, setTotalPatientCount] = useState(0);
    const [primaryCanSite, setPrimaryCanSite] = useState([]);
    const [top10BioMarkers, setTop10BioMarkers] = useState([]);
    const initialValue = 0;
    useEffect(() => {
        handleAllApis();
        //  fetchfun()
        console.log("LandingPage")
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);
    function transsData1(array) {
        if (!Array.isArray(array) || array.length === 0) return [];

        const total = array.reduce((sum, item) => sum + item[1], 0);
        const newarr = array.map(item => ({
            name: item[0] || null,
            value: item[1],
            percent: total > 0 ? Math.round((item[1] / total) * 100) : 0
            // percent: total > 0 ? (item[1] / total) * 100 : 0  
        }));

        return newarr;
    }

    function transsDataTop4(array) {
    if (!Array.isArray(array) || array.length === 0) return [];

    // Total count from ALL sites
    const total = array.reduce((sum, item) => sum + item[1], 0);

    // Map into objects with percent
    const mapped = array.map(item => ({
        name: item[0],
        value: item[1],
        percent: total > 0 ? Math.round((item[1] / total) * 100) : 0
    }));

    // Sort by highest value
    const sorted = mapped.sort((a, b) => b.value - a.value);

    // Return only top 10
    return sorted.slice(0, 10);
}

    function drugDataChange(array) {
        const newState = array?.map((obj) => {
            if (obj?.name === "CHEMOTHERAPY") {
                return { ...obj, name: 'Chemotherapy' };
            }
            else if (obj?.name === "DRUG_THERAPY") {
                return { ...obj, name: 'Hormonal Therapy' };
            }
            else if (obj?.name === "IMMUNOTHERAPY") {
                return { ...obj, name: 'Biological Therapy' };
            }
            return obj;
        })
        return newState
    }
    function treatmentDataChange(array) {
        const newState = array?.map((obj) => {
            if (obj?.name === "Drugs Therapy") {
                return { ...obj, name: 'Systemic Therapy' };
            }
            else if (obj?.name === "Radiation") {
                return { ...obj, name: 'Radiation Therapy' };
            }
            return obj;
        })
        return newState
    }
    function biologicalDataChange(array) {
        const newState = array?.map((obj) => {
            if (obj?.name === "Targeted therapy") {
                return { ...obj, name: 'Targeted Therapy' };
            }
            else if (obj?.name === "Immunotherapy") {
                return { ...obj, name: 'Immuno Therapy' };
            }
            return obj;
        })
        return newState
    }

    const handleAllApis = async () => {
        setIsLoading(true)
        const params = {
            fromDate: null,
            toDate: null,
            cancerSite: null,
            genes: null,
            immunoTherapy: null,
            //lungsAlliance: lungClicked 
        }
        const apiPromises = [
            apiCall("GET", HomePageEndpoints.TreatmentDistribution, params),
            apiCall("GET", HomePageEndpoints.SystematicDrugTherapy, params),
            apiCall("GET", HomePageEndpoints.BiologicalTherapy, params),
            apiCall("GET", ApiEndPoint.Top4CancerSite),
            apiCall("GET", HomePageEndpoints.BioMarkers),
            apiCall("GET", ApiEndPoint.MultiModalTreatments),
            apiCall("GET", ApiEndPoint.Proteomics),
            apiCall("GET", HomePageEndpoints.patientCount, params),
            apiCall("GET", HomePageEndpoints.primaryCancersite, params),
    ];

        try {
            const results = await Promise.allSettled(apiPromises);

            results.forEach((result, index) => {
                if (result.status === 'fulfilled') {
                    try {
                        const data = result.value.data;
                        switch (index) {
                            case 0:
                                const treatmentConvert = transsData1(data?.payLoad)
                                const sortedtrtConvert = treatmentConvert?.sort((a, b) => b.value - a.value);
                                setTreatmentDetails(treatmentDataChange(sortedtrtConvert))
                                console.log("TreatmentData", treatmentConvert)
                                console.log("TreatmentData1", data?.payLoad)
                                const treatmentTotal = treatmentConvert?.reduce(
                                    (accumulator, currentValue) => accumulator + currentValue.value,
                                    initialValue
                                );
                                setTreatmentsTotal(treatmentTotal)
                                break;
                            case 1:
                                const drugConvert = transsData1(data?.payLoad)
                                const sorteddrugConvert = drugConvert?.sort((a, b) => b.value - a.value);
                                setDrugTherapy(drugDataChange(sorteddrugConvert))
                                console.log("DrugTherapyData", drugConvert)
                                const drugTherapyTotal = drugConvert?.reduce(
                                    (accumulator, currentValue) => accumulator + currentValue.value,
                                    initialValue
                                );
                                setDrugTotal(drugTherapyTotal)
                                break;
                            case 2:
                                const biologicalConvert = transsData1(data?.payLoad)
                                const sortedBiologicalConvert = biologicalConvert?.sort((a, b) => b.value - a.value);
                                setBiologicalTherapy(biologicalDataChange(sortedBiologicalConvert))
                                console.log("BiologicalData", biologicalConvert)
                                const bioTherapyTotal = biologicalConvert?.reduce(
                                    (accumulator, currentValue) => accumulator + currentValue.value,
                                    initialValue
                                );
                                setBiologicalTotal(bioTherapyTotal)
                                break;
                            case 3:
                                const top10Cancersite = transsDataTop4(data?.payLoad)
                                setTop10Cancersite(top10Cancersite)
                                break;
                            case 4:
                                const genesList = data?.payLoad || [];
                                setTop10BioMarkers(genesList);
                                break;
                            case 5:
                                // const multiModal = transsData(data?.payLoad)
                                console.log("MultiModal", data?.payLoad)
                                setMultiModal(data?.payLoad)
                                break;
                            case 6:
                                // const proteomics = transsData(data?.payLoad)
                                console.log("Proteomics", data?.payLoad)
                                setProteomics(data?.payLoad)
                                break;
                            case 7:
                                console.log("TotalPatientCount", data?.payLoad)
                                setTotalPatientCount(data?.payLoad)
                                break;
                            case 8:
                                setPrimaryCanSite(data?.payLoad)
                                // console.log("primary", data?.payLoad)
                                break;
                            default:
                                console.log(`No handler for API function ${index + 1}`);
                        }
                    }

                    catch (handlerError) {
                        console.error(`Error handling response for API call ${index + 1}:`, handlerError)
                    }
                } else {
                    console.error(`Error from API call ${index + 1}:`, result.reason);
                    toast.error(`Error fetching data for API at index ${index + 1}`, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            });

        } catch (error) {
            console.error('Error in  setting API calls:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Landing
                treatmentDetails={treatmentDetails}
                drugTherapy={drugTherapy}
                biologicalTherapy={biologicalTherapy}
                treatmentsTotal={treatmentsTotal}
                drugTotal={drugTotal}
                biologicalTotal={biologicalTotal}
                top10Cancersite={top10Cancersite}
                multiModal={multiModal}
                proteomics={proteomics}
                totalPatientCount={totalPatientCount}
                IsLoading={IsLoading}
                primaryCanSite={primaryCanSite}
                top10BioMarkers={top10BioMarkers}
            />
        </>
    )
}
export default LandingScreen
